<mat-progress-bar *ngIf="isFormLoading" mode="indeterminate"></mat-progress-bar>

<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-fieldset [title]="'Global Configuration' | translate">
    <ix-input
      formControlName="basename"
      [label]="'Base Name' | translate"
      [required]="true"
      [tooltip]="tooltips.basename | translate"
    ></ix-input>

    <ix-chips
      formControlName="isns_servers"
      [label]="'ISNS Servers' | translate"
      [tooltip]="tooltips.isns_servers | translate"
    ></ix-chips>

    <ix-input
      formControlName="pool_avail_threshold"
      type="number"
      [label]="'Pool Available Space Threshold (%)' | translate"
      [tooltip]="tooltips.pool_avail_threshold | translate"
    ></ix-input>

    <ix-input
      type="number"
      formControlName="listen_port"
      [label]="'iSCSI listen port' | translate"
      [required]="true"
    ></ix-input>

    <ix-checkbox
      *ngIf="isHaSystem"
      formControlName="alua"
      [label]="'Asymmetric Logical Unit Access (ALUA)' | translate"
      [tooltip]="tooltips.alua | translate"
    ></ix-checkbox>
  </ix-fieldset>

  <ix-form-actions class="form-actions">
    <button
      mat-button
      type="submit"
      color="primary"
      ixTest="save"
      [disabled]="form.invalid || isFormLoading"
    >
      {{ 'Save' | translate }}
    </button>
  </ix-form-actions>
  <div *ngIf="areSettingsSaved" class="saved-message">
    {{ 'Settings saved.' | translate }}
  </div>
</form>
